import React, { useState, useEffect } from 'react';

const Step3Ethnicity = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.ethnicity || null);

  useEffect(() => {
    // Track Meta Pixel PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, []);

  const options = [
    { value: 'caucasian', label: 'Caucasian', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page3-caucasian.webp' },
    { value: 'asian', label: 'Asian', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page3-Asian.webp' },
    { value: 'latina', label: 'Latina', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page3-latina.webp' },
    { value: 'black', label: 'Black', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page3-Black.webp' },
    { value: 'middle-eastern', label: 'Middle Eastern', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page3-Middle.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          ethnicity: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-selection ethnicity-grid">
      <h2 className="step-title">Choose Ethnicity</h2>
      <div className="options-grid">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected === option.value ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step3Ethnicity;